import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
// import { QueryCache } from "@tanstack/react-query";

function Section2_title() {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["headerHome"]);

  const [menuTitle, setmenuTitle] = useState("");
  const [menuSubtitle, setmenuSubtitle] = useState("");
  // useEffect(() => {
  //   axios
  //     .get("https://panel.baghban.restaurant/api/header/home")
  //     .then((response) => {
  //       setmenuTitle(response.data.spotlites[1].title);
  //       setmenuSubtitle(response.data.spotlites[1].text);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }, []);

  useEffect(() => {
    if (data) {
      setmenuTitle(data.spotlites[1].title);
      setmenuSubtitle(data.spotlites[1].text);
    }
  }, [data]);

  return (
    <div className="title-section">
      <h3>{menuTitle}</h3>
      <p className="subtitle-section">{menuSubtitle}</p>
    </div>
  );
}

export default Section2_title;
